import Vue from 'vue';
import Router from 'vue-router';
import CryptoJS from 'crypto-js';
import axios from 'axios';

// Containers
import Full from '@/containers/Full';
import b2b from '@/containers/b2b';

// Views
import dashboard from '@/views/components/dashboard';
import Login from '@/views/components/login';
import InvestigationDefault from '@/views/components/investigationDefault';
import InvScript from '@/views/components/invScript'
import EditDEPSTransferDetails from '@/views/components/editDEPSTransferDetails';
import MarkRTOInvestigation from '@/views/components/markRTOInvestigation';
import markManualDeliveryShipments from '@/views/components/markManualDeliveryShipments';
import ForceFullyLostShipmentsReport from '@/views/components/forceFullyLostShipmentsReport';
import STDAdminReport from '@/views/components/STDAdminReport';
import UCGInventoryReport from '@/views/components/UCGInventoryReport';
import ForcefullyLostDisposeReport from '@/views/components/ForcefullyLostDisposeReport';
import STD from '@/views/components/STD';
import ProductDamageByFinance from '@/views/components/ProductDamageByFinance';
import DisposeBySuperAdmin from '@/views/components/DisposeBySuperAdmin';
import ActionByFinanceForcefullyLostBulk from '@/views/components/ActionByFinanceForcefullyLostBulk';
import AddEditSTDLoggedByExecutive from '@/views/components/AddEditSTDLoggedByExecutive';
import AddEditRaiseDEPSLoggedByCLT from '@/views/components/AddEditRaiseDEPSLoggedByCLT';
import InvestigationActionByOperations from '@/views/components/InvestigationActionByOperations';
import PackagingDamageBySecurityTeam from '@/views/components/PackagingDamageBySecurityTeam';
import AddNTSShipment from '@/views/components/AddNTSShipment';
import OperationExecutiveSearchPage from '@/views/components/B2B/OperatonExcutve/OperationExecutiveSearchPage';
import AddCargoShipment from '@/views/components/B2B/OperatonExcutve/AddCargoShipment';
import EditOperationExecutiveSearchPage from '@/views/components/B2B/OperatonExcutve/EditOperationExecutiveSearchPage';
import FinanceExecutiveSearchPage from '@/views/components/B2B/FinanceExecutive/FinanceExecutiveSearchPage';
import EditFinanceExecutivepage from '@/views/components/B2B/FinanceExecutive/EditFinanceExecutivepage';
import AddCLTExecutiveSearchPage from '@/views/components/B2B/CLTExecutive/AddCLTExecutiveSearchPage';
import EditCLTExecutivepage from '@/views/components/B2B/CLTExecutive/EditCLTExecutivepage';
import DEPSExecutiveSearchPage from '@/views/components/B2B/DEPSExecutive/DEPSExecutiveSearchPage';
import EditDEPSExecutivePage from '@/views/components/B2B/DEPSExecutive/EditDEPSExecutivePage';
import DMGHubExecutiveSearchPage from '@/views/components/B2B/DMGExecutive/DMGHubExecutiveSearchPage';
import EditDMGExecutiveSearchPage from '@/views/components/B2B/DMGExecutive/EditDMGExecutiveSearchPage';
import B2BSearchPage from '@/views/components/B2B/B2BSearchPage';
import rmApprovalPending from '@/views/components/RMApproval/rmApprovalPending';
import editRMApprovalPending from '@/views/components/RMApproval/editRMApprovalPending';
// import summerPageComponent from '@/views/components/summeryPage/';
import DisputeBulkUpload from '@/views/components/DisputeBulkUpload';
import summerPageNewComponent from '@/views/components/summeryPageNew/';
import BulkforClientDebit from '@/views/components/BulkforClientDebit';
import DisputeAcceptRejectUpload from '@/views/components/DisputeAcceptRejectUpload';
import reopenBulkDispute from '@/views/components/reopenBulkDispute';
import DisputeConfigurations from '@/views/components/DisputeConfigurations';
import loggedSingleDispute from '@/views/components/loggedSingleDispute';
import { validateShipmentSummaryAccess, canBypassShipmentSummaryAwbPrefixValidation } from '../common/shipmentSummaryAccess';


// edit

import Edit from '@/views/components/Edit';
import EditSecurity from '@/views/components/EditSecurity';
import EditCLT from '@/views/components/EditCLT';
import EditDEPS from '@/views/components/EditDEPS';
import EditProductDamage from '@/views/components/EditProductDamage';
import EditExcutive from '@/views/components/EditExcutive';
import AddExcutive from '@/views/components/AddExcutive';
import EditActionByFinance from '@/views/components/EditActionByFinance';
import EditSingleDispute from '@/views/components/EditSingleDispute';
import Rec from '@/views/components/Rec';
import apiUrl from '../constants';

Vue.use(Router);


const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [{
        path: 'dashboard',
        name: 'Dashboard',
        component: dashboard,
        meta: {
          requiresAuth: true,
          adminAuth: true,
          breadcrumb: [{
            name: 'Home',
            link: '/dashboard',
          },
          {
            name: 'Dashboard',
          }],
        },

      },
      {
        path: 'b2c',
        name: 'b2c',
        component: Full,
        meta: {
          requiresAuth: true,
          breadcrumb: [{
            name: 'b2c',
            link: 'b2c',
          },
          ],
        },
      },
      {
        path: 'b2b',
        name: 'b2b',
        component: b2b,
        meta: {
          requiresAuth: true,
          breadcrumb: [{
            name: 'b2b',
            link: 'b2b',
          },
          ],
        },
      },
      {
        path: 'InvestigationShipmentsDetails',
        name: 'Investigation Shipments Details',
        component: InvestigationDefault,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'summerPage',
        name: 'Investigation Shipment Summary',
        component: summerPageNewComponent,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'InvScript',
        name: 'invScript',
        component: InvScript,
        meta: {

          breadcrumb: [{
            name: 'invScript',
            link: '/InvScript',
          },
          ],
        },
      },

      {
        path: 'MarkDisputeInvestigate',
        name: 'Mark Dispute Investigate',
        component: MarkRTOInvestigation,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'markManualDeliveryShipments',
        name: 'Mark Manual Delivery Shipments',
        component: markManualDeliveryShipments,
        meta: {
          requiresAuth: true,
        },
      },
          {
        path: 'LogSingleDispute',
        name: 'Log Single Dispute',
        component: loggedSingleDispute,
        meta: {
          requiresAuth: true,
          breadcrumb: [{
            name: 'Log Single Dispute',
            link: '/logSingleDispute',
          },
          ],
        },

      },
      {
        path: 'bulkdisputeupload',
        name: 'DisputeBulkUpload',
        component: DisputeBulkUpload,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'ClientDebitsUpload',
        name: 'BulkforClientDebit',
        component: BulkforClientDebit,
        meta: {
          requiresAuth: true,

        },
      },
      {
        path: 'disputeAcceptRejectMark',
        name: 'Bulk Upload for Accepted/Rejected Disputes',
        component: DisputeAcceptRejectUpload,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'bulkForReopenDispute',
        name: 'Bulk Upload for Dispute Reopening',
        component: reopenBulkDispute,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'ForceFullyLostShipmentsReport',
        name: 'ForceFullyLostShipmentsReport',
        component: ForceFullyLostShipmentsReport,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'ForcefullyLostDisposeReport',
        name: 'ForcefullyLostDisposeReport',
        component: ForcefullyLostDisposeReport,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'STDAdminReport',
        name: 'STDAdminReport',
        component: STDAdminReport,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'UCGInventoryReport',
        name: 'UCGInventoryReport',
        component: UCGInventoryReport,
        meta: {
          requiresAuth: true,
        },

      },
        {
        path: 'EditSingleDispute',
        name: 'Edit Single Dispute',
        component: EditSingleDispute,
        meta: {
          requiresAuth: true,
          breadcrumb: [{
            name: 'Edit Single Dispute',
            link: '/editSingleDispute',
          },
          ],
        },

      },
      {
        path: 'Edit',
        name: 'Edit Action By Operation',
        component: Edit,
        meta: {
          requiresAuth: true,
    
        },

      },
      {
        path: 'EditSecurity',
        name: 'Edit Action By Security',
        component: EditSecurity,
        meta: {
          requiresAuth: true,
        },

      },
      {
        path: 'EditCLT',
        name: 'Edit Action By CLT',
        component: EditCLT,
        meta: {
          requiresAuth: true,
        },

      },
      {
        path: 'EditActionByFinance',
        name: 'Edit Action By Finance',
        component: EditActionByFinance,
        meta: {
          requiresAuth: true,
        },

      },
      {
        path: 'EditDEPS',
        name: 'Edit Action By DEPS',
        component: EditDEPS,
        meta: {
          requiresAuth: true,
        },

      },
      {
        path: "RecStatus",
        name: "RecStatus",
        component: Rec,
        meta: {
          requiresAuth: true,
        },

      }

      ],
    },
    {
      path: '/',
      redirect: '/INVESTIGATION',
      name: 'INVESTIGATION',
      component: Full,
      children: [
        {
          path: 'InvestigationActionByOperations',
          name: 'InvestigationActionByOperations',
          component: InvestigationActionByOperations,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'AddEditRaiseDEPSLoggedByCLT',
          name: 'AddEditRaiseDEPSLoggedByCLT',
          component: AddEditRaiseDEPSLoggedByCLT,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'PackagingDamageBySecurityTeam',
          name: 'PackagingDamageBySecurityTeam',
          component: PackagingDamageBySecurityTeam,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'AddNTSShipment',
          name: 'AddNTSShipment',
          component: AddNTSShipment,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'EditDEPSTransferDetails',
          name: 'EditDEPSTransferDetails',
          component: EditDEPSTransferDetails,
          meta: {
            requiresAuth: true,
          },
        },
      ],

    },
    {
      path: '/',
      redirect: '/STD',
      name: 'STD',
      component: Full,
      children: [{
        path: 'ProductDamageByFinance',
        name: 'ProductDamageByFinance',
        component: ProductDamageByFinance,
        meta: {
          requiresAuth: true,
        },
      }, {
        path: 'DisposeBySuperAdmin',
        name: 'DisposeBySuperAdmin',
        component: DisposeBySuperAdmin,
        meta: {
          requiresAuth: true,
         
        },
      },
      {
        path: 'ActionByFinanceForcefullyLostBulk',
        name: 'ActionByFinanceForcefullyLostBulk',
        component: ActionByFinanceForcefullyLostBulk,
        meta: {
          requiresAuth: true,
         
        },
      }, {
        path: 'DamagedByOperations',
        name: 'Damaged By Operations',
        component: AddEditSTDLoggedByExecutive,
        meta: {
          requiresAuth: true,
          
        },
      },
      {
        path: 'EditProductDamage',
        name: 'Edit Product Damage',
        component: EditProductDamage,
        meta: {
          requiresAuth: true,
         
        },

      },
      {
        path: 'EditExcutive',
        name: 'Edit ',
        component: EditExcutive,
        meta: {
          requiresAuth: true,
         
        },

      },
      {
        path: 'AddExcutive',
        name: 'Add Damage By Operation',
        component: AddExcutive,
        meta: {
          requiresAuth: true,
       
        },

      },
      ],
    },
    {
      path: '/',
      redirect: '/Configurations',
      name: 'Configurations',
      component: Full,
      children: [
        {
          path: 'disputeConfigs',
          name: 'WH Handover Disputes - Client Configuration',
          component: DisputeConfigurations,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/login/:id?',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      redirect: '/B2B',
      name: 'B2B',
      component: Full,
      children: [
        {
          path: 'B2BSearchPage',
          name: 'B2BSearchPage',
          component: B2BSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Shipment Details',
              link: '/B2BSearchPage',
            },
            ],
          },
        },
        {
          path: 'OperationExecutiveSearchPage',
          name: 'OperationExecutiveSearchPage',
          component: OperationExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Operation Executive',
              link: '/OperationExecutiveSearchPage',
            },
            ],
          },
        },
        {
          path: 'AddCargoShipment',
          name: 'AddCargoShipment ',
          component: AddCargoShipment,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Add/Edit Cargo Damage',
              link: '/AddCargoShipment',
            },
            ],
          },
  
        },
        {
          path: 'EditOperationExecutiveSearchPage',
          name: 'EditOperationExecutiveSearchPage ',
          component: EditOperationExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Add/Edit Cargo Damage',
              link: '/EditOperationExecutiveSearchPage',
            },
            ],
          },
  
        },
        {
          path: 'FinanceExecutiveSearchPage',
          name: 'FinanceExecutiveSearchPage',
          component: FinanceExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Finance Executive',
              link: '/FinanceExecutiveSearchPage',
            },
            ],
          },
        },
        {
          path: 'EditFinanceExecutivepage',
          name: 'EditFinanceExecutivepage',
          component: EditFinanceExecutivepage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Finance Executive',
              link: '/EditFinanceExecutivepage',
            },
            ],
          },
        },
        {
          path: 'CLTExecutiveSearchPage',
          name: 'AddCLTExecutiveSearchPage',
          component: AddCLTExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'CLT Executive',
              link: '/CLTExecutiveSearchPage',
            },
            ],
          },
        },
        {
          path: 'EditCLTExecutivepage',
          name: 'EditCLTExecutivepage',
          component: EditCLTExecutivepage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Add/Edit Cargo Damage',
              link: '/EditCLTExecutivepage',
            },
            ],
          },
        },
        {
          path: 'DEPSExecutiveSearchPage',
          name: 'DEPSExecutiveSearchPage',
          component: DEPSExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'DEPS Executive',
              link: '/DEPSExecutiveSearchPage',
            },
            ],
          },
        },
        {
          path: 'EditDEPSExecutivePage',
          name: 'EditDEPSExecutivePage',
          component: EditDEPSExecutivePage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Add/Edit Cargo Damage',
              link: '/EditDEPSExecutivePage',
            },
            ],
          },
        },
        {
          path: 'DMGHubExecutiveSearchPage',
          name: 'DMGHubExecutiveSearchPage',
          component: DMGHubExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'DMG Executive',
              link: '/DMGHubExecutiveSearchPage',
            },
            ],
          },
        },
        {
          path: 'EditDMGExecutiveSearchPage',
          name: 'EditDMGExecutiveSearchPage',
          component: EditDMGExecutiveSearchPage,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
              name: 'Add/Edit Cargo Damage',
              link: '/EditDMGExecutiveSearchPage',
            },
            ],
          },
        },
      ],

    },
    {
      path: '/',
      redirect: '/RMApproval',
      name: 'RMApproval',
      component: Full,
      children: [
        {
          path: 'rmApprovalPending',
          name: 'rmApprovalPending',
          component: rmApprovalPending,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'editRMApprovalPending',
          name: 'editRMApprovalPending',
          component: editRMApprovalPending,
          meta: {
            requiresAuth: true,
          },
        },
       
      ],

    },
  ],
});

router.beforeEach((to, from, next) => {
  const isShipmentSummaryRoute = to.path === '/summerPage';
  if (to.path === '/summerPage') {
    const awb = (to.query && to.query.awb ? to.query.awb : '').toString().trim();
    const accessKey = (to.query && to.query.accessKey ? to.query.accessKey : '').toString().trim();
    const username = (window.localStorage.getItem('username') || '').toString().trim();
    const canBypassAccessValidation = canBypassShipmentSummaryAwbPrefixValidation(username);
    if (awb && !canBypassAccessValidation && !validateShipmentSummaryAccess(awb, accessKey)) {
      if (Vue.prototype.$alertify && typeof Vue.prototype.$alertify.error === 'function') {
        Vue.prototype.$alertify.error('Shipment Summary can only be opened from a Shipping ID link.');
      }
      next({ path: '/InvestigationShipmentsDetails' });
      return;
    }
  }
  let isLoggedIn = window.localStorage.getItem('isLoggedIn');
  const accessuserToken = window.localStorage.getItem('accessuserToken') ? window.localStorage.getItem('accessuserToken').replace(/"/g, '') : null;

  if (isLoggedIn == null) {
    isLoggedIn = false;
  } else if (accessuserToken == null) {
    localStorage.removeItem('accesshubdata');
    localStorage.removeItem('accesspermissiondata');
    localStorage.removeItem('accessuserdata');
    localStorage.removeItem('accessuserToken');
    localStorage.removeItem('isLoggedIn');
    isLoggedIn = false;
  } else {
    isLoggedIn = true;
  }

  if (to.matched.some((record) => record.meta.requiresAuth) && !isLoggedIn) {
    // this.$router.push({ name: 'login', query: { redirect: '/path' } });
    next({
      path: '/login',
    });
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    const permissionEncrypt = window.localStorage.getItem('accesspermissiondata');
    const bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    const permissiondata = JSON.parse(plaintext);

    function isBigEnough(findURL) {
      if (findURL.children.length > 0) {
        for (let j = 0; j < findURL.children.length; j++) {
          if (findURL.children[j].ismenu === true) {
            return findURL.children.some(isBigChildEnough);
          }
        }
      }
      return findURL.name == to.name;
    }
    function isBigChildEnough(findURL) {
      return findURL.name == to.name;
    }

    const setroles = permissiondata.some(isBigEnough);
    if (setroles || isShipmentSummaryRoute) {
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js